import React from 'react'

export default props => (
  <svg viewBox="0 0 14 14" {...props}>
    <path d="M13.6422222,1.73444444 L12.5611111,0.427777778 C12.3511111,0.163333333 12.0322222,0 11.6666667,0 L2.33333333,0 C1.96777778,0 1.64888889,0.163333333 1.43111111,0.427777778 L0.357777778,1.73444444 C0.132222222,1.99888889 0,2.34888889 0,2.72222222 L0,12.4444444 C0,13.3 0.7,14 1.55555556,14 L12.4444444,14 C13.3,14 14,13.3 14,12.4444444 L14,2.72222222 C14,2.34888889 13.8677778,1.99888889 13.6422222,1.73444444 Z M7,11.2777778 L2.72222222,7 L5.44444444,7 L5.44444444,5.44444444 L8.55555556,5.44444444 L8.55555556,7 L11.2777778,7 L7,11.2777778 Z M1.64888889,1.55555556 L2.27888889,0.777777778 L11.6122222,0.777777778 L12.3433333,1.55555556 L1.64888889,1.55555556 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/archive.js